// "צפה בניתוח" (2026-10-23): read the SAVED deep analysis of the Home card's workout — GET /chat/deep-analysis.
// Read only: it never calls /chat/analyze-workout or /chat, so viewing can never start a new (paid) generation.
// The workout is the card's own (trend.deep_analysis_ref: its date + lead activity id); the backend finds the
// saved analysis at any age — the chat screen loads the latest 100 messages only.
// Returns { status: 'ok', text, date } | { status: 'not_found' } | { status: 'error' }.
export async function fetchSavedDeepAnalysis(fetcher, apiBase, uid, trend) {
  const ref = trend?.deep_analysis_ref || {};
  const date = ref.date || trend?.today_workout?.date;
  const params = new URLSearchParams({ user_id: uid });
  if (ref.activity_id !== undefined && ref.activity_id !== null) params.set('activity_id', String(ref.activity_id));
  if (date) params.set('date', String(date).slice(0, 10));
  try {
    const res = await fetcher(`${apiBase}/chat/deep-analysis?${params}`);
    if (!res || !res.ok) return { status: 'error' };
    const data = await res.json();
    const text = data?.analysis?.response;
    if (data?.status === 'ok' && text) return { status: 'ok', text, date: data.date || date };
    return { status: 'not_found' };
  } catch (e) {
    return { status: 'error' };
  }
}
